/* eslint-disable react/jsx-key */
import { useEffect, useState } from 'react';
import Footer from '@/components/Layout/Footer/Footer';
import sub from '@/assets/sub.png';
import room from '@/assets/room.png';
import seeker from '@/assets/seeker.png';
import loc from '@/assets/loc-add.png';
import town from '@/assets/town1.png';
import town2 from '@/assets/town2.png';
import town3 from '@/assets/town3.png';
import arrow from '@/assets/btn-arrow.png';
import { ContentLayout } from '@/components/Layout';
import { Button } from '@/components/Elements';
import i18next from 'i18next';
import home from '@/assets/living-img.png';
import temp from '@/assets/temp.png';
import car from '@/assets/car-solid.png';
import edu from '@/assets/edu.png';
import tub from '@/assets/hot-tub-.png';
import work from '@/assets/work.png';
import party from '@/assets/party.png';
import rest from '@/assets/rest.png';
import clean from '@/assets/clean.png';
import misc from '@/assets/misc.png';
export const AgencyDeals = () => {
  return (
    <>
      <ContentLayout title={i18next.t('Agency Deals')}>
        <section className="agency-tabssec">
          <div className="container">
            <div className="agency-deals-box relative d-flex flex-wrap align-items-center">
              <div className="agency-deal-content">
                <div className='agency-abs-cont'>
                <h2 className="f-50 font-semibold text-black mb-0">7 Bedroom HMO- </h2>
                <h2 className="f-50 font-semibold mb-0 border-potetial text-black">
                  Potential Of £42,000 PA
                </h2>
                <div className="location-box flex gap-2 mt-4 items-center">
                  <img src={loc} className="loc-icon" />
                  <div className="loc-content">
                    <p className="f-14 light-color">
                      St. Cikoko Timur, Kec. Pancoran, Jakarta Selatan, <br /> Indonesia 12770
                    </p>
                  </div>
                </div>
                <hr />
                <p className="f-13 deals-box-tto">
                  Discover a world where opulence meets comfort as you explore luxry residences that
                  redefine
                </p>
              </div>
              </div>
              <div className="agency-deal-image">
                <img src={sub} className="agenacy-sb" />
              </div>
              <div className="deals-right-box">
                <p className="f-13">
                  Explore elegant residences that epitomize the perfect blend of style, Luxury and
                  Comfort.
                </p>
                <img src={seeker} className="deal-seeker w-100" />
                <div className="relative deals-banenr">
                  <img src={room} className="deal-banne w-100" />
                  <div className="banner-abd">
                    <Button className="white-btn bg-white rounded-full">
                      <soan className="d-flex gap-1">
                        View All <img src={arrow} className="deal-arw" />
                      </soan>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="locations-box">
              <div className="town-box">
                <div className="town-content twn">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="town-details  town-bg p-2">
                        <div className="town-img">
                          <img src={town} alt="pay1" />
                        </div>
                        <div className="town-text">
                          <h6 className="mb-0 light-color f-13">Town</h6>
                          <p className="mb-0 text-black f-14">958M4MJ3+47</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="town-details  town-bg p-2">
                        <div className="town-img">
                          <img src={town2} alt="pay1" />
                        </div>
                        <div className="town-text">
                          <h6 className="mb-0 light-color f-13">Town</h6>
                          <p className="mb-0 text-black f-14">958M4MJ3+47</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="town-details  town-bg p-2">
                        <div className="town-img">
                          <img src={town3} alt="pay1" />
                        </div>
                        <div className="town-text">
                          <h6 className="mb-0 light-color f-13">Phone Number</h6>
                          <p className="mb-0 text-black f-14">9867676665</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="deals-facilities mb-5">
          <div className="container">
            <div className="row facility-rw">
              <div className="col-12 col-md-6">
                <div className="facility-col-dic">
                  <div className="facelities-left face-bg p-3 rounded-10">
                    <h5 className="text-black mb-4">Facilities</h5>
                    <div className="facelities-box-flex d-flex align-items-center justify-center  gap-4">
                      <div className="facelities-box text-center pe-4  ">
                        <div className="living-img  ">
                          <img src={home} alt="living" />
                        </div>
                        <p className="mb-0 text-black  fs-12">Living Spaces</p>
                      </div>

                      <div className="facelities-box  text-center pe-4  ">
                        <div className="living-img  ">
                          <img src={temp} alt="living" />
                        </div>
                        <p className="mb-0 text-black fs-12">Climate Control</p>
                      </div>
                      <div className="facelities-box   text-center pe-4  ">
                        <div className="living-img  ">
                          <img src={tub} alt="living" />
                        </div>
                        <p className="mb-0 text-black  fs-12">Amenities</p>
                      </div>
                      <div className="facelities-box  text-center pe-4  ">
                        <div className="living-img  ">
                          <img src={car} alt="living" />
                        </div>
                        <p className="mb-0 text-black fs-12">Functional Spaces4</p>
                      </div>
                      <div className="facelities-box  text-center pe-4  ">
                        <div className="living-img  ">
                          <img src={misc} alt="living" />
                        </div>
                        <p className="mb-0 text-black fs-12">Miscellaneous</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="face-bg desired-housing p-3 rounded-10">
                  <div className="row">
                    <div className="col-12 col-md-6 col-xl-3 mb-2">
                      <p className="f-13">#33255 </p>
                      <p className="text-black f-14">Property Id</p>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mb-2">
                      <p className="f-13">05</p>
                      <p className="text-black f-14">Accepted Request</p>
                    </div>

                    <div className="col-12 col-md-6 col-xl-3 mb-2">
                      <p className="f-13">05 </p>
                      <p className="text-black f-14">Requested Agency</p>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mb-2">
                      <p className="f-13">6%</p>
                      <p className="text-black f-14">ROI</p>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mb-2">
                      <p className="f-13">$50</p>
                      <p className="text-black f-14">Cashflow (PKM)</p>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mb-2">
                      <p className="f-13">8%</p>
                      <p className="text-black f-14">Finder Fee</p>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mb-2">
                      <p className="f-13">Yes</p>
                      <p className="text-black f-14">Signed Document</p>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3 mb-2">
                      <p className="f-13">15-11-24 16:47 pm</p>
                      <p className="text-black f-14">Date</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="face-bg  p-3 rounded-10 below-facility mt-4">
              <div className="row">
                <div className="col-12 col-md-7">
                  <h5 className="w-max pb-2 border-bottom">About the Home</h5>
                  <p className="f-13">
                    For a limited time only, we have managed to secure an income producing six
                    bedrooms HMO within proximity to Manchester City Centre.
                  </p>
                  <ul className="seeker-list f-13">
                    <li>
                      The property is currently rented and achieving a total of £4,032 pcm = £48,384
                      per annum
                    </li>
                  </ul>
                  <p className="f-13">The property briefly comprises:</p>
                  <ul className="seeker-list f-13">
                    <li>6 Bedrooms HMO</li>
                    <li>4 Bathrooms</li>
                    <li>Large Kitchen Dining Space to the Rear</li>
                    <li>Large Kitchen Dining Space to the Rear</li>
                  </ul>
                  <p className="f-13">
                    The property is conveniently situated in a perfect location within proximity to
                    excellent transport connections, primary schools, local shops, and all the local
                    amenities.
                  </p>
                </div>
                <div className="col-12 col-md-5">
                  <div className="map"></div>
                  <div className="location-box flex gap-2 mt-4 items-center">
                    <img src={loc} className="loc-icon" />
                    <div className="loc-content">
                      <p className="f-14 light-color">
                        St. Cikoko Timur, Kec. Pancoran, Jakarta Selatan, <br /> Indonesia 12770
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </ContentLayout>
    </>
  );
};
